import React, { MouseEventHandler, useEffect, useState } from "react";

import "../css/components.css";

interface ButtonTogglerPropTypes {
  onFirstBtnTap: MouseEventHandler<HTMLDivElement>;
  onSecondBtnTap: MouseEventHandler<HTMLDivElement>;
  isFirstBtnSelected: boolean;
  firstBtnText: string;
  secondBtnText: string;
}

function ButtonToggler(props: ButtonTogglerPropTypes) {
  const {
    onFirstBtnTap,
    onSecondBtnTap,
    firstBtnText,
    secondBtnText,
    isFirstBtnSelected,
  } = props;

  return (
    <div className="test_center_toggler_container">
      <div
        onClick={onFirstBtnTap}
        className="test_center_toggler_item test_center_toggler_item_first_btn"
        style={{ backgroundColor: isFirstBtnSelected ? "blue" : "white" }}
      >
        <text style={{ color: isFirstBtnSelected ? "white" : "black" }}>
          {firstBtnText}
        </text>
      </div>
      <div
        onClick={onSecondBtnTap}
        className="test_center_toggler_item test_center_toggler_item_second_btn"
        style={{ backgroundColor: isFirstBtnSelected ? "white" : "blue" }}
      >
        <text style={{ color: isFirstBtnSelected ? "black" : "white" }}>
          {secondBtnText}
        </text>
      </div>
    </div>
  );
}

export default ButtonToggler;
